import { Component, computed, effect, inject, signal } from "@angular/core"
import { UserManagerService } from "./user-manager.service"
import { UserManagerEditComponent } from "./user-manager-edit.component"
import { ProfileService } from "../user-profile/profile.service"
import { PageToolbarService } from "../page-toolbar.service"
import { UiInheritDirective } from "ui-inherit"
import { UiCollapseComponent } from "ui-collapse"
import { RolesEnum } from "redlineLibs"

@Component({
  imports: [
    UserManagerEditComponent,
    UiInheritDirective,
    UiCollapseComponent,
  ],
  standalone: true,
  template: `
    <div #pageToolbarPlaceholder [style.height.px]="pageToolbarHeight()"></div>
    <div
      class="column"
      style="padding: 20px; gap: 0"
    >
      @if (!isUserAdmin()) {
        Access Denied
      }
      Admin Users
      @if (adminUsers().length) {
        @for (user of adminUsers(); track user.userId; let index = $index; let first = $first; let last = $last) {
          <lib-ui-collapse
            [first]="first"
            [last]="last"
            [index]="index"
            (activated)="adminUsersIndex.set($event)"
          >
            <ng-container ngProjectAs="title-left">
              {{ user.header }}
            </ng-container>
            <ng-container ngProjectAs="content">
              @defer (when index === adminUsersIndex()) {
                <e2e-user-manager-edit
                  [userProfile]="user.userProfile"
                  [userId]="user.userId"
                />
              }
            </ng-container>
          </lib-ui-collapse>
        }
      }
      Non-Admin Users
      @if (nonAdminUsers().length) {
        @for (user of nonAdminUsers(); track user.userId; let index = $index; let first = $first; let last = $last) {
          <lib-ui-collapse
            [first]="first"
            [last]="last"
            [index]="index"
            (activated)="usersIndex.set($event)"
          >
            <ng-container ngProjectAs="title-left">
              {{ user.header }}
            </ng-container>
            <ng-container ngProjectAs="content">
              @defer (when index === usersIndex()) {
                <e2e-user-manager-edit
                  [userProfile]="user.userProfile"
                  [userId]="user.userId"
                />
              }
            </ng-container>
          </lib-ui-collapse>
        }
      }
    </div>
  `,
  selector: "e2e-user-manager",
})
export class UserManagerComponent {
  private userManagerService = inject(UserManagerService)
  private profileService = inject(ProfileService)
  private pageToolbarService = inject(PageToolbarService)

  isUserAdmin = this.profileService.isUserAdmin
  pageToolbarHeight = this.pageToolbarService.pageToolbarHeight

  adminUsersIndex = signal(-1)
  adminUsers = computed(() =>
    this.users().filter((user) =>
      this.userManagerService.userAuthCustomClaims()[user.userId]?.roles?.includes(RolesEnum.ADMIN)
    )
  )

  nonAdminUsers = computed(() =>
    this.users().filter((user) =>
      !this.userManagerService.userAuthCustomClaims()[user.userId]?.roles?.includes(RolesEnum.ADMIN)
    )
  )

  usersIndex = signal(-1)
  users = computed(() =>
    [...this.userManagerService.userProfiles_map().values()]
      .map((userProfile) => ({
        ...userProfile,
        userProfile: userProfile,
        header: userProfile.userName
          ? userProfile.userName // + " (" + userProfile.userEmail + ") "
          : userProfile.userEmail + " ",
      }))
      .sort((a, b) => {
        const nameA = a.userName || a.userEmail
        const nameB = b.userName || b.userEmail
        return nameA.localeCompare(nameB)
      }),
  )

  // adminUsers = computed(() =>
  //   this.users().filter(user =>
  //     this.profileService.isUserAdmin(user.userProfile)
  //   )
  // )

  constructor() {
    effect(() => this.pageToolbarHeight()) // triggers template refresh when pageToolbarHeight changes
  }

}
